// extracted by mini-css-extract-plugin
export default {"root":"styles_root__wLwa9","title":"styles_title__UyaNL","button":"styles_button__4UWfo"};